import { InfoPage } from '@reactjscomponentrepository/frontend-components/lib/components';
import React from 'react';

export const Page404 = () => {
  return (
    <>
      <InfoPage>
        <h1>Página no encontrada</h1>
      </InfoPage>
    </>
  )
}
